// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__RN1_c","footer":"ModalFilter_footer__2GrYb"};